/*
	Handles all the loader prep for the property listing page
 */
function fnStoreFinder( i, oSection ) {

	var oSearchBar 			= $( oSection ),
		oAjaxContent 		= $( 'section.store-ajax-wrap' );




	
	//	Prevent the return key from submitting the form from the get go
	$('form',oSearchBar).on('keyup keypress', function(event) {
	  var keyCode = event.keyCode || event.which;
	  if (keyCode === 13) { 
	    event.preventDefault();
		return false;
	  }
	});


	$('form',oSearchBar).keyup(delay(function (event) {
	  var keyCode = event.keyCode || event.which;
	  if (keyCode === 13) { 
	    formSubmit(event);
	  }
	}, 500));



	//	Form submit trigger
	$( 'button.submit', oSearchBar ).on( 'click', function( event ) {
		formSubmit(event);
	});



	function formSubmit(event){
		var bAllowedSearch = false;

		//	Mark as true is an address is entered
		$('#search-box, #search-lat, #search-lng').each(function(iKey, oInput ) {
			var sValue = $(oInput).val();
			if(sValue.length > 0){
				bAllowedSearch = true;
			}
		});

		if(!bAllowedSearch){
			alert('Please enter a location first.');
			return;
		}
		
		fireAjax();

		// stop the form from submitting the normal way and refreshing the page
		event.preventDefault();
		return false;
	}

	/*
	*	Loads the map in when the map pin icon is clicked
	*	Will sort existing content as well
	 */
	function fireAjax(){
		oAjaxContent.addClass('searching');



		//	Prep submit data
		var oFormData = {
            'action'				: 'search_stores',
            'store_search'			: $('input[name=store_search]').val(),
            'store_search_lat'		: $('input[name=store_search_lat]').val(),
            'store_search_lng'		: $('input[name=store_search_lng]').val(),
            'store_search_radius'	: $('select[name=store_search_radius]').val(),
            'store_search_company'	: $('select[name=store_search_company]').val()
            //'paged_number'			: $('section.pagination a.current').attr('data-page')
        };

		$.ajax({
			'data': oFormData,
			'dataType': 'json',
			'type': 'GET',
			'url': ajax_url,	//	This is set through the theme-inlcudes.php file
			'complete': function() {

			},
			'success': function(oResponse) {

				oAjaxContent.empty();

				//	Add the new content in
				oAjaxContent.append( oResponse.sResult );
				//oAjaxContent.append( oResponse.sPropertyGrid );
				//oAjaxContent.append( oResponse.sPagination );
				$('section',oAjaxContent).hide().fadeIn(850);


				$( '.google-map' ).each(fnGoogleMap);



				// Remove the loading spinner
				oAjaxContent.removeClass('searching');


				// Configure tabs
				fnLocatorTabs();


			}
		});
	}

	/***************
	* Tabs
	***************/
	function fnLocatorTabs() {

		var oContent		= $( '.content-wrap', oSection ),
			oMap			= oContent.find( '.map' ),
			oList			= oContent.find( '.list' );

		// Map
		$( 'i.map' ).on( 'click', function() {

			$( this ).addClass( 'current' ).siblings( 'i' ).removeClass( 'current' );

			oList.fadeOut(600);
			oMap.delay(600).fadeIn(600);

		});

		// List
		$( 'i.list' ).on( 'click', function() {

			$( this ).addClass( 'current' ).siblings( 'i' ).removeClass( 'current' );

			oMap.fadeOut(600);
			oList.delay(600).fadeIn(600);

		});

	}

	//	To delay the tryping in delay for the enter key
	function delay(callback, ms) {
	  var timer = 0;
	  return function() {
	    var context = this, args = arguments;
	    clearTimeout(timer);
	    timer = setTimeout(function () {
	      callback.apply(context, args);
	    }, ms || 0);
	  };
	}

}


// END OF DOCUMENT
